import React from 'react'

export default function Productrisk() {
  return (
    <div>
      <h1>Product and Risk Advice</h1>
    </div>
  )
}
